<template>
  <div class="listPage">
    <spinner v-if="activateSpinner" class="mt-3"></spinner>
    <div v-else>
      <table v-if="items.length"
        class="table table-striped"
        role="table"
        :aria-label="$t('orphan.orphan_list_table')">
        <caption class="sr-only">{{ $t('orphan.orphan_list_caption') }}</caption>
        <thead>
          <tr>
            <th scope="col" v-for="field in fields" :key="field.key" :class="field.class">
              {{ field.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="index" @click="seeOrphansDetails([item])" class="cursor-pointer">
            <td :class="fields[0].class">
              <span>{{ getDate(item.CreationDate) }}</span>
            </td>
            <td :class="fields[1].class">
              <div class="text-ellipsis">{{ item.Reference }}</div>
            </td>
            <td :class="fields[2].class">
              <div class="text-ellipsis">{{ item.CompanyName != '' ? item.CompanyName : item.FirstName +' '+ item.LastName}}</div>
            </td>
            <td :class="fields[3].class">
              <div class="text-ellipsis">{{ item.IdScore != '' ? item.IdScore : item.NameScore }}</div>
            </td>
            <td :class="fields[4].class">
              <div class="text-ellipsis">{{ item.Type }}</div>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else class="d-flex justify-content-center">
        <span class="noResult">
          {{ $t('common.no_result') }}
        </span>
      </div>
    </div>
    <b-row class="mt-5">
      <b-col>
        <b-col cols="12">
          <cm-pagination
            :maxResultsByPage="paginationObject.maxResults"
            :firstIndex="paginationObject.firstIndex"
            :nbResultsTotal="paginationObject.nbResultsTotal"
            :refreshEvent="paginationObject.refresh">
          </cm-pagination>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import moment from 'moment-timezone';

//import moment from "moment";

import MessagesFilter from "@/components/common/Filter";
import Spinner from "@/components/common/spinner.vue";
import Pagination from "@/components/common/pagination.vue";

import { errorMessageAlert } from "@/helpers/alert";
import services from "@/helpers/services";
import { downloadFileWithDefinedHeaders } from '@/helpers/download';
import dateTimePicker from "@/components/common/dateTimePicker.vue";
import {loadPage} from "@/helpers/routing";

export default {
  name: "OprhanFlux",
  components: {
    "cm-messages-filter": MessagesFilter,
    "spinner": Spinner,
    'datetime-picker-custom': dateTimePicker,
    "cm-pagination": Pagination,
  },
  props: {
    direction: {
      default: "2",
      type: String,
    },
    modeFilter: {
      default: "4",
      type: String,
    },
    filterType: {
      type: String,
      default: 'list'
    },
    filters: {
      type: Object,
      default: () => ({})
    },
    displayFilter: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.timezone = moment.tz.guess()
    this.$bus.$emit("change-mobile-header", {
      backLink: false,
      navbarInnerStyle: "justify-content:start;",
      navTitle: this.$t('Webheader.orphan'),
      returnUrl: "",
    });
    this.paginationObject["firstIndex"] = 1;
    this.paginationObject["maxResults"] = 15
    this.paginationObject["nbResultsTotal"] = 0;
    // this.$engine.firstOn().services.payments.filter.cleanFilterCondition()
    this.mode = parseInt(this.modeFilter, 10);
    let that = this;
    this.$engine.firstOn().settings.set({ msgDirection: this.direction });

    this.clearingListCreated = false

    this.$bus.$on('language-changed', () => {
      that.fields = [
        { key: "CreationDate", label: this.$t('common.date_label'), class: 'text-center' },
        { key: "Reference", label: this.$t('orphan.reference'), class: "text-center" },
        { key: "Name", label: this.$t('orphan.name'), class: "text-center" },
        { key: "MatchingResult", label: this.$t('orphan.matching_result_label'), class: "text-center font-weight-bold" },
        { key: "Type", label: this.$t('orphan.type'), class: "text-center font-weight-bold" }
      ]
      that.onRefresh(false)
      that.pageCounter = 0
    })

    this.$bus.$off("refresh-cache-contacts");
    this.paginationObject['refresh'] = 'inbox-filtered'
    this.$bus.$off('inbox-filtered')
    this.$bus.$off('refresh-inbox-on-seen')
    this.$bus.$on('inbox-filtered', index => {
      that.onRefresh(false, index)
      that.pageCounter = 0
    })
    // No need to listen for toggle-filter anymore as filters are in parent

    this.$bus.$off('apply-filters-orphan')
    this.$bus.$on('apply-filters-orphan', () => {
      // Filters are now passed as props, just apply them
      this.applyFilter()
    })

    this.$bus.$off('refresh-orphan')
    this.$bus.$on('refresh-orphan', () => {
      this.onRefresh(false)
    })

    this.$bus.$off('export-orphan')
    this.$bus.$on('export-orphan', () => {
      this.extractCSV()
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false);
  },
  mounted() {
    this.$$(".infinite-scroll-preloader").remove();
    this.$bus.on("service:change", (val) => {
      this.serviceId = this.$engine.firstOn().services.getServiceIdByName(val);
    });
  },
  beforeDestroy() {
    // Nettoyer les event listeners
    this.$bus.$off('apply-filters-orphan')
    this.$bus.$off('refresh-orphan')
    this.$bus.$off('export-orphan')
  },
  data () {
    return {
      activateSpinner: false,
      clearingList: [],
      clearingListCreated: false,
      filterConditions: {},
      items: [],
      keyTableFlux: false,
      mode: 8,
      type: '',
      MatchingResult: '',
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      scrollFlag: true,
      services: services,
      serviceId: this.$engine.firstOn().user.currentService.id.toString(),
      serviceName: this.$t("common.appname"),
      randomString: Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)
    };
  },
  computed: {
    Reference () {
      return this.filters?.Reference || ''
    },
    Name () {
      return this.filters?.Name || ''
    },
    dateBegin () {
      return this.filters?.dateBegin || ''
    },
    dateEnd () {
      return this.filters?.dateEnd || ''
    },
    resultTypeList () {
      return this.filters?.resultTypeList || {}
    },
    fields () {
      return [
        { key: "CreationDate", label: this.$t('common.date_label'), class: 'text-center' },
        { key: "Reference", label: this.$t('orphan.reference'), class: "text-center" },
        { key: "Name", label: this.$t('orphan.name'), class: "text-center" },
        { key: "MatchingResult", label: this.$t('orphan.matching_result_label'), class: "text-center font-weight-bold" },
        { key: "Type", label: this.$t('orphan.type'), class: "text-center font-weight-bold" }
      ]
    },
    customMobileLayoutStyle() {
      if (this.serviceId === services.PAYMENTS) {
        return 'h-136px;'
      } else {
        return 'h-90px;'
      }
    },
  },
  watch: {
    filters: {
      deep: true,
      handler(newFilters) {
        // When filters change from parent, we might want to trigger a refresh
        // This is optional - only if you want automatic refresh on filter change
      }
    }
  },
  methods: {
    getDate (date) {
      if (!date) return '-';

      // Si la date ne contient pas un offset explicite (+00:00, +04:00, etc.) ou 'Z', on suppose qu’elle est en UTC
      const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/.test(date);
      const isoWithTZ = hasTimezone ? date : date + 'Z';

      return moment(isoWithTZ).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss.SSS');
    },
    activateDetail (id) {
      let that = this
      loadPage(that, {url: '/orphan/' + id})
    },
    seeOrphansDetails (items) {
      this.activateDetail(items[0].IdOrphan)
    },
    applyFilter (filterConditions = {}) {
      let that = this

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0
      this.activateSpinner = true
      filterConditions.Reference = this.Reference
      filterConditions.Name = this.Name
      let filterMatchingResult = ''
      let first = true
      for (let resultTypeListKey in this.resultTypeList) {
        if (this.resultTypeList[resultTypeListKey].state){
          if (first) {
            filterMatchingResult += "\'" +resultTypeListKey+ "\'"
            first = false
          } else {
            filterMatchingResult += ",\'" + resultTypeListKey+ "\'"
          }
        }
      }
      filterConditions.MatchingResult = filterMatchingResult
      filterConditions.dateBegin = this.dateBegin != '' ? moment(this.dateBegin, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      filterConditions.dateEnd = this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      filterConditions.maxResults = this.paginationObject.maxResults
      filterConditions.firstIndex = this.paginationObject.firstIndex
      this.$engine.firstOn().orphan.getOrphans(
        filterConditions
      ).then(resp => {
        let orphans = {}
        that.paginationObject.nbResultsTotal = resp.data.nbTotalOprhans
        that.paginationObject.nbResults = resp.data.orphans.length
        orphans = resp.data.orphans
        that.updateItems(orphans)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    extractCSV (inboxMessages) {
      let that = this


      let filterConditions = {
        extract: 1,
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex,
      }

      this.$engine.firstOn().orphan.getOrphans(
        filterConditions
      ).then(resp => {
        that.$f7.hidePreloader()
        const linkSource = 'data:text/csv;charset:utf-8;base64,' + resp.data
        const downloadLink = document.createElement('a')
        let today = moment()
        const fileName ='Orphan_' + today.unix() + '.csv'
        if (
            this.$f7.device.os === 'android' ||
            this.$f7.device.os === 'ios'
        ) {
          downloadFileWithDefinedHeaders(this, fileName, linkSource)
        } else {
          downloadLink.href = linkSource
          downloadLink.download = fileName
          downloadLink.click()
        }
        this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getClearingTitleColor (clearing, index) {
      return 'clearing-color-' + clearing.toLowerCase()
    },
    getMessageTypeLabel (id) {
      return this.$t('filter.orphan.message_type.' + id)
    },
    isDataJSON (data) {
      let raw = data.substr(23)
      raw = atob(raw)
      try {
        return JSON.parse(raw)
      } catch (e) {
        return false
      }
    },
    onRefresh (noAttach = false, index = 1) {
      let that = this
      this.pageCounter = 0
      this.paginationObject["firstIndex"] = index
      this.paginationObject["nbResultsTotal"] = 0
      this.activateSpinner = true
      let filterConditions = {}
      filterConditions.Reference = this.Reference
      filterConditions.Name = this.Name
      let filterMatchingResult = ''
      let first = true
      for (let resultTypeListKey in this.resultTypeList) {
        if (this.resultTypeList[resultTypeListKey].state){
          if (first) {
            filterMatchingResult += "\'" +resultTypeListKey+ "\'"
            first = false
          } else {
            filterMatchingResult += ",\'" + resultTypeListKey+ "\'"
          }
        }
      }
      filterConditions.MatchingResult = filterMatchingResult
      filterConditions.dateBegin = this.dateBegin != '' ? moment(this.dateBegin, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      filterConditions.dateEnd = this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      this.$engine.firstOn().orphan.getOrphans(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let orphans = {}
        that.paginationObject.nbResultsTotal = resp.data.nbTotalOprhans
        that.paginationObject.nbResults = resp.data.orphans.length
        orphans = resp.data.orphans
        that.updateItems(orphans)
        that.updateInbox(orphans, noAttach)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      }).catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    seeXml (data, service, action) {
      let that = this
      const id = data.id
      const type = data.type ? data.type : 'Technical_Error'
      let xmlDetails = {}
      this.$engine.firstOn().services.payments
        .getXml(service, type, id)
        .then((resp) => {
          if (resp.data) {
            xmlDetails = resp.data
            xmlDetails.type = type
            if (action === 'see') {
              that.$bus.emit('popup-xml-details', xmlDetails)
            } else {
              //download file
              let extension = '.xml'
              let message = that.$i18n.t('common.xml_downloaded')
              if (that.isDataJSON(resp.data.data)) {
                extension = '.json'
                message = that.$i18n.t('common.json_downloaded')
              }
              const fileName = moment().format('YYYYMMDD_hhmmss_') + type + extension
              downloadFileWithDefinedHeaders(that, fileName, resp.data.data)
              that.$f7.alert('', message)
            }
          }
        })
        .catch((error) => {
          errorMessageAlert(error, that)
        })
    },
    updateInbox (orphans, noAttach = false) {
      this.inboxMessages = orphans
      if (orphans.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          // this.attachInfinit()
        }
      } else {
        // this.detachInfinit()
      }
    },
    updateItems (orphans) {
      this.items = []
      this.items = orphans
      // for (var i = 0; i < orphans.length; i++) {
      //
      //   if (!this.clearingList.includes(orphans[i].standard)) {
      //     this.clearingList.push(orphans[i].standard)
      //   }
      //
      //   let date = orphans[i].datetime
      //
      //   let result = {
      //     id: orphans[i].id,
      //     idFormatIn: orphans[i].id_format_in,
      //     direction: orphans[i].direction,
      //     dateTime: date,
      //     clearing: orphans[i].standard,
      //     msgType: orphans[i].messageType,
      //     initParty: orphans[i].initParty,
      //     msgId: orphans[i].msgId,
      //     flow: orphans[i].type
      //   }
      //   this.items.push(result)
      // }
    }
  },
};
</script>
